/**
 * @file automatically generated from MApp.Spatial.Ogc.LineJoin
 */

export enum LineJoin {
    Round = 0,
    Mitre = 1,
    Bevel = 2
}
/**
 * @file automatically generated from MApp.Spatial.Ogc.LineCap
 */

export enum LineCap {
    Butt = 0,
    Round = 1,
    Square = 2
}
